
import { defineComponent } from 'vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';
import MultiStatusModal from '@/components/multi-status/MultiStatusModal.vue';

interface PartResultItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'PartResultItem',
  components: {
    EnlargeIcon,
    PreviewImageModal,
    MultiStatusModal
  },
  data(): PartResultItemProps {
    return {
      baseFileUrl,
      showPreviewModal: false,
      previewImg: [],
      showMultiStatusModal: false
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    partName: {
      type: String,
      required: true,
      default: ''
    },
    modelNum: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0) {
        if (partsImgs[0].fileUrl) {
          res = baseFileUrl + partsImgs[0].fileUrl;
        }
      }
      return res;
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    onImgClick() {
      this.previewImg.push(this.getImg);
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    async handleAfterMultiStatusClose(data, isCancel) {
      this.showMultiStatusModal = false;
      if (isCancel) {
        return;
      }
      if (data) {
        this.$router.push(
          `/partdetail/${data.diagramId}?name=${this.partName}&modelNum=${this.modelNum}`
        );
      }
    },
    gotoPart() {
      if (this.item.differentStatus === 1) {
        this.showMultiStatusModal = true;
      } else {
        this.$router.push(
          `/part-detail/${this.item.id}/${this.item.vehicleId}/?name=${this.partName}&modelNum=${this.modelNum}`
        );
      }
    }
  }
});
